import Api from '../../../Api'
import { combineReducers } from "redux";
import createTableFetcher from 'common/reducer/createTableFetcher'

const getFetcher = state => state.waas.searchServiceById.fetcher;
export const fetcher = createTableFetcher('SEARCH_BY_LOG_ID', Api.searchByLogID, getFetcher);

export const actions = fetcher.actions;

export const initialState = {

}

const searchServiceId = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
}

export default combineReducers({
    fetcher: fetcher.reducer,
    searchServiceId
})
